import { useTheme } from '@mui/material';
import { colors } from '@constants/colors';
import { useMytaverse } from '@providers/MytaverseProvider';
import { ScreenSizes } from '@interfaces';

export const useStyles = (
  primary: boolean,
  white: boolean,
  compact: boolean,
) => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const getColor = (isPrimaryWhite = false) => {
    if (isPrimaryWhite) {
      return {
        color: colors.black,
        backgroundColor: colors.white,
        border: `1px solid ${colors.white}`,
      };
    }

    return {};
  };

  return {
    root: {
      fontSize: compact ? 14 : 20,
      padding: compact ? '8px 22px' : '13px 32px',
      borderRadius: '99px',
      minWidth: '96px',
      fontWeight: 500,
      lineHeight: 1.4,
      textTransform: 'none',
      color: primary ? colors.white : white ? colors.white : colors.black,
      borderColor: primary
        ? appTheme.mainColor
        : white
        ? colors.white
        : colors.black,
      backgroundColor: primary ? appTheme.mainColor : 'transparent',
      ...getColor(primary && white),
      '&:hover': {
        borderColor: primary
          ? appTheme.mainColor
          : white
          ? colors.white
          : colors.black,
        backgroundColor: primary ? appTheme.mainColor : 'transparent',
        ...getColor(primary && white),
      },
      '&:disabled': {
        color: colors.white,
        backgroundColor: colors.grey_third,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: compact ? '8px 22px' : '10px 18px',
        fontSize: compact ? 14 : 18,
      },
    },
  };
};
